var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ErrorHandler } from '@angular/core';
import * as Raven from "raven-js";
var RavenErrorHandler = /** @class */ (function () {
    function RavenErrorHandler() {
    }
    RavenErrorHandler.prototype.handleError = function (err) {
        Raven.captureException(err);
    };
    return RavenErrorHandler;
}());
export { RavenErrorHandler };
// Note that reject promises will set this error handler off
var GlobalErrorHandler = /** @class */ (function (_super) {
    __extends(GlobalErrorHandler, _super);
    function GlobalErrorHandler() {
        return _super.call(this) || this;
    }
    GlobalErrorHandler.prototype.handleError = function (error) {
        console.error(error);
        _super.prototype.handleError.call(this, error);
    };
    return GlobalErrorHandler;
}(RavenErrorHandler));
export { GlobalErrorHandler };
